import SearchModel from'./SearchModel';
class AutoModel {
    id              = -1
    model           = ""
    number          = ""
    color           = ""
    descAuto        = ""
    infoAuto        = ""
    
    searchModel = null;
}

export default AutoModel